import { render, staticRenderFns } from "./NewScan.vue?vue&type=template&id=a9405716&scoped=true&"
import script from "./NewScan.vue?vue&type=script&lang=js&"
export * from "./NewScan.vue?vue&type=script&lang=js&"
import style0 from "./NewScan.vue?vue&type=style&index=0&id=a9405716&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9405716",
  null
  
)

export default component.exports